import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class PriceBandListQueryFilter extends QueryFilter{
  public organizationId: string;
}
